// extracted by mini-css-extract-plugin
module.exports = {"signup":"signedup_signup__h6tTc","container":"signedup_container__1Rv-5","form":"signedup_form__2F0ZM","label":"signedup_label__3g7SC","input":"signedup_input__1ZjjY"};